import { render, staticRenderFns } from "./HorizontalBar.vue?vue&type=template&id=0481e273&"
import script from "./HorizontalBar.vue?vue&type=script&lang=js&"
export * from "./HorizontalBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports